import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { MenuMappingService } from "../../../services/menuMapping.service";


@Component({
  selector: "addEditInvoice",
  templateUrl: "./addEditInvoice.html",
})
export class AddEditSalesInvoiceComponent {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  execApi: boolean = true;
  partyData : any ={}

  invoicedata: any = {
    rate_type: "",
    invoice_type: "",
    corcharge: 0,
    boxless: 0,
    taxper: 5,
    disper: 0,
    salesorder: false,
    rate: 0,
    no_of_bundles: 0,
    remarks: '',
    narration: ''
  };
  delPartyList: any;
  delscanned_by: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  onsaveDisable : boolean = false;
  designList: any;
  invalidList: any = [];
  invoiceTypeList = ["ESTIMATE", "INVOICE"];
  rateTypeList = ["FLAT RATE", "DISCOUNT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  partyList: any;
  scanned_by: any;
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.sale_type = val["sale_type"];
    this.to_sale_type = val["to_sale_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    console.log(val);
    this.invoicedata = invoicedata;
    this.invoicedata.disper = invoicedata.disper;
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (
      this.mode == "Convert" ||
      this.mode == "Edit" ||
      this.mode == "View" ||
      this.mode == "Restore"
    ) {
      console.log(this.mode, this.invoicedata)
      this.invoicedata.boxless = Number(this.invoicedata.boxless);
      this.editInvoiceList();
      this.barcodeList();
      //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.oncheck(this.invoicedata.salesorder);
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    public datePipe: DatePipe,
    public MappingService: MenuMappingService,
    public toasterService: ToasterService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    //(<any>$("#tableres")).colResizable({liveDrag:true});

    this.getSalesParty();
    this.getUserList();
    this.getSeason();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.invoicedata.sales_type = this.sale_type;


    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.invoicedata.taxper = 5;
      this.invoicedata.boxless = 0;
      this.invoicedata.no_of_bundles = 0;
      this.getAutoNumber();
      //this.getAuto();
    }
   if (this.mode == "Convert") {
      this.convertAutoNumber();

      if (this.to_sale_type == "proformaWholesale") {
      this.invoicedata.taxper = 0;
      }
    }
  }
  ngAfterViewInit() {
    if (this.sale_type == "retail") {
      setTimeout(() => {
        $("#invoice_type").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#partyname").focus();
      }, 100);
    }
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }
  convertAutoNumber() {

    let params = {
      trans_type: this.to_sale_type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };
    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      res.auto_no;

      let checkdata = {
        inv_no: res.auto_no,
        sales_type: this.to_sale_type
      }

      this.salesinvservice.checkInvno(checkdata).then((res: any) => {
        this.invoicedata.invoiceno = res.invoiceno;
        this.invoicedata.convertno_dc_id = res.dc_id;
        this.invoicedata.convert_type = res.convert_type;
      });
  });
  }
  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass('mat-autocomplete-visible');
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
  
    const selectedRow = that.data.invoiceList[ind];

    if (this.mode === 'Edit' && selectedRow.isFetchedInEdit) {
      swal({
        title: `Can't remove previously added barcodes`,
        timer: 2500,
        type: "warning",
        showCancelButton: false,
        showConfirmButton: false,
      });

      return;
    }

    const targetBagBarcode = selectedRow.bag_barcode;
  
    swal({
      title: targetBagBarcode
        ? `All rows with this bag will be deleted. Proceed?`
        : "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length > 1) {
          let rowsToDelete = [];
  
          if (targetBagBarcode) {
            // Collect all rows with the same bag_barcode
            rowsToDelete = that.data.invoiceList.filter(
              row => row.bag_barcode === targetBagBarcode
            );

            // Calculate total boxless value from rows to be deleted
            const totalBoxlessToRemove = rowsToDelete.reduce((sum, row) => {
              return sum + (row.boxless_value || 0);
            }, 0);

            // Subtract the total boxless value before deletion
            that.invoicedata.boxless -= totalBoxlessToRemove;
            // Remove them
            that.data.invoiceList = that.data.invoiceList.filter(
              row => row.bag_barcode !== targetBagBarcode
            );

            if (this.invoicedata.bagBarcodeData && this.invoicedata.bagBarcodeData.length) {
              this.invoicedata.scannedBarcodeCountAgainstBag + 0;
            }

          } else {
            rowsToDelete = [selectedRow];
             that.invoicedata.boxless -= that.data.invoiceList[ind]["boxless_value"] || 0;
            that.data.invoiceList.splice(ind, 1);
          }
  
          // Adjust boxless if needed
          // if (that.box === "YES" || (that.invoicedata.boxless > 0 && that.mode === "Edit")) {
          //   that.invoicedata.boxless -= rowsToDelete.length * 10;
          // }
  
          that.calctot();
  
          // Focus logic
          let newInd = ind - 1;
          if ($("#" + this.page_id + fld + "-" + newInd).length > 0) {
            $("#" + this.page_id + fld + "-" + newInd).focus();
          } else if ($("#" + this.page_id + fld + "-" + ind).length > 0) {
            $("#" + this.page_id + fld + "-" + ind).focus();
          }
        }
      },
      function (dismiss) {}
    );
  }
  
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.invoiceList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    let params = {
      trans_type: this.sale_type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    if (this.sale_type == "wholesale" || this.sale_type == "proformaWholesale") {
      this.salesinvservice.getAutoNumber(params).then((res: any) => {

        let check_invno = res.auto_no;
        let data = {
          inv_no: check_invno,
          sales_type: this.sale_type
        }

        this.salesinvservice.checkInvno(data).then((res: any) => {


          this.invoicedata.invoiceno = res.invoiceno;
          this.invoicedata.convertno_dc_id = res.dc_id;
          this.invoicedata.convert_type = res.convert_type;
        });


      });
    }
    else {
      this.salesinvservice.getAutoNumber(params).then((res: any) => {
        this.invoicedata.invoiceno = res.auto_no;

      });
    }
  }
 getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
      console.log(this.partyList);
      if (this.sale_type == "retail") {
        this.invoicedata.party_name = "RETAIL";
      }
      console.log("sales screeen", this.sale_type, this.mode)
      if(this.mode == 'Edit' && this.sale_type == 'estimate')
        this.partyData = this.partyList.find(e => e.genLedid == this.invoicedata.party_id)
      });

  }
  getUserList(){
      this.MappingService.getUserList({}).then((res: any) => {
        this.scanned_by = res.data;
        console.log(this.scanned_by);
        });
  }

  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
      type: "invoice",
    };
    this.salesinvservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.partyCtrl.setValue(this.invoicedata["season"]);
        this.invoicedata.season = res.data.season;
      } else {
        swal("PLEASE PUT THE SEASON FIRST!");
      }
    });
  }
  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  checkBarcode(code) {
    if (code.length == 7) {
      if (this.execApi) {
        this.execApi = false;

        let params = {
          barcode: code,
          trans_type: this.sale_type,
          party_id: this.invoicedata.party_id
        };
        for (let i = 0; i < this.data.invoiceList.length; i++) {
          code = parseInt(code);
          this.data.invoiceList[i].barcode = parseInt(
            this.data.invoiceList[i].barcode
          );
          if (this.data.invoiceList[i].barcode == code) {
            setTimeout(() => {
              this.invoicedata.barcode = "";
              $("#code").focus();
            }, 500);

            swal({
              title: "Barcode Already Exists",
              timer: 1000,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.execApi = true;
            return;
          }
        }

        this.salesinvservice.checkBarcode(params).then((res: any) => {
          if (this.sale_type == "estimate" || this.sale_type == "wholesale") {
            if (res.data.length == 0 && res.message == "Access Denied") {
              swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
              this.execApi = true;
              this.invoicedata.barcode = "";
              return;
            }
          }

          if (res.data.length == 0) {
            //   swal("Selected Design is invalid!");
            swal({
              title: res.message,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 1000,
            });
            let invalidData = {
              barcode: code,
              type: "invoice",
            };
            this.invalidList.push(invalidData);
            this.invoicedata.barcode = "";
            this.execApi = true;
            return;
          }

          const isValidBarcodeRes = this.isValidBarcode(res.data);
          console.log("isValidBarcodeRes :: ", isValidBarcodeRes);
          if (!isValidBarcodeRes.status) {
            swal({
              title: isValidBarcodeRes.message,
              timer: 2500,
              type: "warning",
              showCancelButton: false,
              showConfirmButton: false,
            });
            this.execApi = true;
            return;
          }

          let row = Object.assign(
            {
              f36: 0,
              f38: 0,
              f40: 0,
              f42: 0,
              f44: 0,
              f46: 0,
              h36: 0,
              h38: 0,
              h40: 0,
              h42: 0,
              h44: 0,
              h46: 0,
            },
            res.data
          );
          row[row.size.toLowerCase()] = 1;
          row.fqty = row.f36 + row.f38 + row.f40 + row.f42 + row.f44 + row.f46;
          row.hqty = row.h36 + row.h38 + row.h40 + row.h42 + row.h44 + row.h46;
          row.totqty = row.hqty + row.fqty;
          row.boxless_value = 0;
          if (this.invoicedata.rate_type == "FLAT RATE") {
            row.rate = this.invoicedata.rate;
          }

          this.data.invoiceList.push(row);

          var bottom = document.querySelector("#salesTbody");
          setTimeout(() => {
            bottom.scrollTop = bottom.scrollHeight;
          }, 300);

          this.calcBox(res.data.boxless_style);
          this.calctot();
          this.execApi = true;
          this.invoicedata.barcode = "";
        });
      }
    }
  }

  isValidBarcode(barcodeRes: any): { status: boolean; message?: string; } {
    let message = '';

    if (this.invoicedata.bagBarcodeData && this.invoicedata.bagBarcodeData.length) {
      if (barcodeRes.bag_barcode) {
        if (this.invoicedata.bagBarcodeData[0].bag_barcode !== barcodeRes.bag_barcode) {
          message = `Scanned bag and shirt mapped bag are not matched`;
        } else {
          const findBarcodeInBag = this.invoicedata.bagBarcodeData.find(x => x.barcode === barcodeRes.barcode);

          if (!findBarcodeInBag) {
            message = `${barcodeRes.barcode} is not exist in bag (${this.invoicedata.bagBarcodeData[0].bag_barcode})`
          } else {
            this.invoicedata.scannedBarcodeCountAgainstBag += 1;

            if (this.invoicedata.bagBarcodeData.length === this.invoicedata.scannedBarcodeCountAgainstBag) {
              this.invoicedata.bagBarcodeData = [];
              this.invoicedata.bag_barcode = '';
              this.focusField("bag_barcode");
            }
          }
        }
      } else {
        message = `Single barcode can't be scan while the bag is scanned. Please scan the barcode against the bag (${this.invoicedata.bagBarcodeData[0].bag_barcode})`;
      }
    } else {
      if (barcodeRes.bag_barcode) {
        message = `Barcode is mapped to bag(${barcodeRes.bag_barcode}). Not allowed to scan seperately.`;
      }
    }

    return { status: !Boolean(message), message };
  }

  focusField(id: 'code' | 'bag_barcode') {
    setTimeout(() => {
      const input = document.getElementById(id) as HTMLInputElement;
      if (input) {
        input.focus();
      }
    }, 0);    
  }

  getBagBarcodeDetails(barcode: string) {
    if (this.execApi) {
      barcode = barcode.trim();

      if (!barcode) {
        this.invoicedata.bagBarcodeData = [];
        this.invoicedata.scannedBarcodeCountAgainstBag = 0;
        this.focusField('code');
        return;
      }

      this.execApi = false;

      const params = {
        bag_barcode: barcode,
        party_id: this.invoicedata.party_id,
        trans_type: this.sale_type,
      };

      // Split into prefix and padded number
      let [prefix, paddedNumber] = params.bag_barcode.split('-');

      // Remove leading zeros
      let originalNumber = paddedNumber ? paddedNumber.replace(/^0+/, '') : paddedNumber;

      // Handle case like 'B3-000000' → 'B3-0'
      if (originalNumber === '') {
        originalNumber = '0';
      }

      // Combine back to short format
      let shortCode = `${prefix}-${originalNumber}`;
      params.bag_barcode = shortCode;

      this.salesinvservice.checkBarcode(params).then((res: any) => {
        if (!res.data.length) {
          swal({
            title: res.message,
            timer: 2500,
            type: "warning",
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.invoicedata.bagBarcodeData = [];
          this.invoicedata.scannedBarcodeCountAgainstBag = 0;
          this.invoicedata.bagBarcode = '';
          this.execApi = true;
          return;
        }

        this.invoicedata.bagBarcodeData = res.data;
        this.invoicedata.scannedBarcodeCountAgainstBag = 0;
        this.focusField('code');
        this.execApi = true;
      });
    } else {
      swal({
        title: 'Processing. Wait for sometimes.',
        timer: 2500,
        type: "warning",
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
    if (this.mode == "Convert" && this.listSelected.length > 0) {
      let listarray = [];
      let selarray = [];
      let that = this;
      listarray = that.data.invoiceList.filter(function (n) {
        return that.listSelected.indexOf(n) > -1 ? false : n;
      });
      let design1 = listarray;
      let desList1 = [];
      for (let i = 0; i < design1.length; i++) {
        if (design1[i].design_no != "") {
          desList1.push(design1[i]);
        }
      }

      selarray = desList1;
      that.data.invoiceList = that.listSelected;
      that.listSelected = selarray;
    }
    let design = this.data.invoiceList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.invoiceList = desList;

    this.onSaveInvoice();
  }

  onSaveInvoice(): void {
    if (
      this.invoicedata.party_name == undefined ||
      this.invoicedata.season == undefined ||
      this.invoicedata.corcharge == null ||
      this.invoicedata.corcharge == undefined
      || (!this.invoicedata.scanned_by && this.sale_type != 'retail')
    ) {
      swal("Make sure that the party name, order.no or season entered");
    } else {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;
      params["boxless"] = this.invoicedata.boxless || 0;
      params["no_of_bundles"] = this.invoicedata.no_of_bundles || 0;
      params["salesorder"] = this.invoicedata.salesorder || false;
      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);
      if (this.mode == "Convert") {
        params["estinvoice"] = JSON.stringify(this.listSelected);
      }
      params["del_party_id"] = "";
      params["dcdt"] = this.datePipe.transform(params["dcdt"], "yyyy-MM-dd");
      if (this.invoicedata.mode == "Convert") {
        params["mode"] = "Add";
        params["estimate_dcid"] = this.invoicedata.dcid;
        params["sales_type"] = this.to_sale_type;
      }

      if (
        this.sale_type != "retail" &&
        this.invoicedata.mode !== "Convert" &&
        this.mode !== "Restore" &&
        this.mode !== 'Edit'

      ) {
        let order = this.partyOrderno.filter((i) =>
          this.invoicedata.so_no.includes(i.so_no)
        );
        this.order = order[0]["order_type"];

        if (this.order == "Open Order") {
          params["soGrid"] = JSON.stringify(this.data.invoiceList);
          params["ES"] = "OPENORDERLIST";
          if (this.mode == "Edit") params["bl"] = JSON.stringify(this.bl);
        }
      }

      let that = this;

      swal({
        title: "Are you sure to save this Invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
          that.onsaveDisable = true;
          console.log("check disableFlag::", that.onsaveDisable)
        that.isLoadMask = that.salesinvservice
          .saveUpdateSalesInvoice(params)
          .then(function (res: any) {
            if (res.message == "Access Denied") {
              swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
              return false
            }
            else {
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              if (res.success) {
                 that.onsaveDisable = false;
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              } else {
                if (that.mode == "Restore") {
                  swal("Sorry! You can only restore the last invoice...");
                } else {
                  swal("ERROR", res.message, "error");
                }
              }
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
  calcBox(style) {
    console.log(this.box, this.partyData, style)
    // if (this.box == "YES"|| (this.invoicedata.boxless > 0 && this.mode == "Edit")) {
    //   this.invoicedata.boxless += 10;
    // }
    const styleKey = style.toLowerCase();

    if (this.partyData.inv_reflect && this.partyData.inv_reflect === "1")
      if ((this.partyData.hasOwnProperty(styleKey) && this.partyData[styleKey] === "1") || ((style == 'CLUB' || style == 'RR FORMAL') && this.partyData["formal"] === "1") || (style == 'RR CASUAL' &&  this.partyData["casual"] === "1")) {
        this.invoicedata.boxless += 10;
        this.data.invoiceList[this.data.invoiceList.length - 1]["boxless_value"] = 10;
        console.log("Boxless increased to:", this.partyData.inv_reflect, this.partyData[styleKey], styleKey, this.data.invoiceList); // Output: Boxless increased to: 10
      }
  }
  onSelectInvoiceType(type) {
    if (type == "ESTIMATE") {
      this.invoicedata.disper = 100;
      this.invoicedata.taxper = 0;

    } else {
      this.invoicedata.disper = 0;
      this.invoicedata.taxper = 5;
    }
  

    if (this.sale_type == "retail" && type == "INVOICE") {
      let params = {
        trans_type: "wholesale",
        date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
      };
      this.salesinvservice.getAutoNumber(params).then((res: any) => {
        this.invoicedata.invoiceno = res.auto_no;
      });
    }
    else if(this.sale_type == "retail" && type == "ESTIMATE"){
      let params = {
        trans_type: "retail",
        date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
      };
      this.salesinvservice.getAutoNumber(params).then((res: any) => {
        this.invoicedata.invoiceno = res.auto_no;
      });
    }
  }

    onSelectPartyName(name) {
      let partylist = _.filter(this.partyList, { name: name });

      if (this.mode == 'Edit') {
        return
      }
      // else if(this.mode == 'Edit'){

      // }
      else if (this.mode != "Convert") {
        this.invoicedata.agent_id = partylist[0]["agent_id"];
        this.invoicedata.party_id = partylist[0]["genLedid"];
        this.invoicedata.disper = 0;

        if (partylist[0]["disc_applicable"] == 'YES') {
          this.invoicedata.disper = partylist[0]["discount"];
        }

        this.invoicedata.transport = partylist[0]["transport"];
        this.invoicedata.pack_style = partylist[0]["pack_style"];
      }
      this.box = partylist[0]["boxless"];
       this.partyData = partylist[0];

      if (this.mode == "Add") {
        if (this.sale_type == "retail") {
          $("#customer_name").focus();
        } else {
          $("#so_no").focus();
        }
      }

      let params = {
        party_id: this.invoicedata.party_id,
        party_name: name,
        season: this.invoicedata.season,
      };
      this.salesinvservice.getPartyOrderNumber(params).then((res: any) => {
        this.partyOrderno = res;
      });
    }
    // saveOpenOrderDetails(){
    //     let params: any = Object.assign({}, this.invoicedata);
    //     params['tabevent'] = undefined;
    //     params['mode'] = this.mode;
    //     params['soGrid'] = JSON.stringify(this.data.invoiceList);
    //     params['ES'] = 'OPENORDERLIST';

    //         this.isLoading = true;
    //         this.salesservice
    //             .adduptSalesOrder(params)
    //             .then((res: any) => {
    //             });

    // }
    editInvoiceList() {
      let params = {
        start: 0,
        limit: 100,
        page: 1,
        dcid: this.invoicedata.dcid,
        sale_type: this.sale_type
      };
      this.salesinvservice.getSiEntryGridShirtSizeDet(params).then((res: any) => {
        this.data.invoiceList = res.data.map(x => {
          return { ...x, isFetchedInEdit: true }
        });
        this.calctot();
        var bottom = document.querySelector("#salesTbody");
        bottom.scrollTop = bottom.scrollHeight;
      });
    }
    barcodeList() {
      let params = {
        start: 0,
        limit: 100,
        page: 1,
        dcid: this.invoicedata.dcid,
      };
      this.salesinvservice.getBarcodeOpenOrder(params).then((res: any) => {
        this.bl = res.data;
      });
    }
    oncheck(ischeck) {
      if (ischeck == true || ischeck == "true") {
        this.invoicedata.salesorder = true;
      } else {
        this.invoicedata.salesorder = false;
      }
    }

    calctot() {
      let ftot = 0,
        htot = 0,
        tot = 0;
      for (let i = 0; i < this.data.invoiceList.length; i++) {
        ftot += parseInt(this.data.invoiceList[i]["fqty"]);
        this.invoicedata.ftotal = ftot;
        htot += parseInt(this.data.invoiceList[i]["hqty"]);
        this.invoicedata.htotal = htot;
        tot += parseInt(this.data.invoiceList[i]["totqty"]);
        this.invoicedata.total = tot;
      }
    }
  }



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesInvoice/addEditInvoice.ts